import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { EMPTY_STR } from "@/constants/string";
import { TStandardIndustryClassificationForm } from "@/features/master-data/types/masterDataStandardIndustryForm";
import { text } from "@/theme/colors";
import { Box, Typography } from "@mui/material";
import { FC } from "react";
import { Control, useWatch } from "react-hook-form";

type TClassificationCodeFieldProps = {
  control: Control<TStandardIndustryClassificationForm>;
  parentFullCode: string;
};

export const ClassificationCodeField: FC<TClassificationCodeFieldProps> = ({ control, parentFullCode }) => {
  const code = useWatch({ control, name: "code" });
  const previewFullCode = `${parentFullCode}${code ?? ""}`;

  return (
    <Box>
      <FormField control={control} name="code">
        <Input />
      </FormField>
      <Typography variant="cap12" color={text.secondary} sx={{ mt: 0.5, display: "block" }}>
        {`分類コード: ${previewFullCode || EMPTY_STR.TEXT}`}
      </Typography>
    </Box>
  );
};
